const Education = () => {
  return (
    <div>
      <h1 className="mt-8 mb-4 flex items-center text-3xl font-bold leading-relaxed tracking-wide dark:text-gray-100">
        <span className="text-gradient-animated mr-2 font-mono tracking-tight">
          Education
        </span>
      </h1>
      <div className="flex items-center dark:text-gray-300 font-mono tracking-tight">
        <div className="flex-1">
          {/* <span className="text-sm text-gray-600">
            Aug. 2011 - Aug. 2016 · Hanoi 🇻🇳
          </span> */}
          <div className="font-bold tracking-wide">
            Information Technology <br /> (Conducted in English) <br />
            Bachelor&apos;s Degree
          </div>
          <a
            href="https://hust.edu.vn"
            target="_blank"
            rel="noopener noreferrer"
            className="
            text-md
            block
            pb-2
            text-gray-700
            transition-colors
            duration-150
            ease-in
            hover:text-teal-500
            dark:text-gray-100
          "
          >
            Hanoi University of Science & Technology
          </a>
        </div>
      </div>
    </div>
  )
}

export { Education }
